<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <Header/>
  <b-card class="bCardAgenda">
    <b-container fluid>
        <b-row>
          <b-col cols="3">
            <label>Búsqueda por: </label>
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  v-model="radioSelect"
                  :options="options"
                  :aria-describedby="ariaDescribedby"
                  name="radio-inline"
                  @input="limpiarDatosTabla()"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <br>
            <b-row class="contenedorTablaSinColor" style="background:white" v-if="radioSelect == 'idTratamiento'">
              <b-col  >
                <b-input-group class="pl-3" >
                  <b-form-input
                      class="input-filter"
                      maxLength="8"
                      v-model="filtro"
                      type="search"
                      id="filterInput"
                      responsive
                      placeholder="Búsqueda por id Tratamiento"
                      @keydown.enter.native="obtenerHistorialRegistros()"
                  >
                  </b-form-input>
                </b-input-group>
              </b-col>
            </b-row>

            <b-row class="contenedorTablaSinColor" style="background:white" v-else>
              <b-col  >
                <b-input-group class="pl-3" >
                  <b-form-input
                      class="input-filter"
                      maxLength="8"
                      v-model="filtroPlan"
                      type="search"
                      id="filterInput"
                      responsive
                      placeholder="Búsqueda por id Plan"
                      @keydown.enter.native="obtenerHistorialRegistros()"
                  >
                  </b-form-input>
                </b-input-group>
              </b-col>
            </b-row>

          </b-col>
          <b-col cols="1">
            <br>
            <b-button variant="light" pill>
              <b-icon
                  class="punteroMano"
                  icon="search"
                  variant="info"
                  v-on:click="obtenerHistorialRegistros()"
              ></b-icon>
            </b-button>
          </b-col>
          <b-col cols="8">
          </b-col>
        </b-row>

<!--      <b-row class="contenedorTablaSinColor" style="background:white">
        <b-col sm="12" lg="12" cols="9" md="6" >
          <b-input-group class="pl-3" >
            <b-form-input
                class="input-filter"
                v-model="filter"
                type="search"
                id="filterInput"
                responsive
                placeholder="Búsqueda de Tratatamiento"
            >

            </b-form-input>
            <b-input-group-append >
              <b-dropdown
                  class="input-filter"
                  @hide="search.etapaSearch = ''"
                  variant="white"
                  responsive
              >
                <template #button-content>
                    <span :class="filtrosSeleccionados.length > 0 ? 'filtro' : 'filtro-normal'">
                      {{ filtrosSeleccionados.length > 0 ? '(' + filtrosSeleccionados.length + ') Filtros' : 'Filtros' }}
                    </span>
                </template>
              </b-dropdown>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>-->
    <b-row class="contenedorTablaSinColor text-center mt-4" >

      <p></p>
    <b-col sm="12" lg="12" cols="9" md="6" >
      <b-table
          :fields="fieldsTratamientos"
          :items="tratamientosArray"
          :per-page="perPage"
          :current-page="currentPage"
          responsive
          thead-tr-class="columnasTablaSinColor"
          caption-top
          :filter="filter"
          :filter-included-fields="filterOn"
          v-bind="tratamientosArray"
      >



        <template v-slot:cell(fechaAlta)="row">
          {{ row.item.fechaAlta | formatoFechaHora }}
        </template>
      </b-table>
      <b-alert variant="warning" show v-if="tratamientosArray.length == 0" >Sin datos </b-alert>
      <b-spinner variant="success" v-if="cargando"></b-spinner>
      <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
      ></b-pagination>
    </b-col>
  </b-row>
  </b-container>
  </b-card>
</div>
</template>

<script>
import Header from "../Header";
export default {
  name: "TratamientosPlanesInactivos",
  components: { Header},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    currentPage: 1,
    perPage: 10,
    totalRows: 1,
    filter: null,
    filterOn: [],
    tratamientosArray: [],
    fieldsTratamientos: [
      { key: "idPlanTratamiento", label: "ID", sortable: true, sortDirection: "desc" },
      {
        key: "idTratamiento",
        label: "ID Trat.",
        sortable: true,
        sortDirection: "desc",
      },{
        key: "nombreTratamiento",
        label: "Tratamiento",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "idPlan",
        label: "ID Plan",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "nombrePlan",
        label: "Plan",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "nombrePersona",
        label: "Persona",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "fechaAlta",
        label: "Fecha Baja",
        sortable: true,
        sortDirection: "desc",
      },
    ],
    filtro: null,
    filtroPlan: null,
    radioSelect: 'idTratamiento',
    options: [
      { text: 'Id Tratamiento', value: 'idTratamiento' },
      { text: 'IdPlan', value: 'idPlan' },
    ],
    cargando: false,
}),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    limpiarDatosTabla(){
      this.tratamientosArray = [];
      this.filtro= null;
      this.filtroPlan = null;
    },
    obtenerHistorialRegistros() {
      this.cargando = true;
      const params = {
        idTratamiento: this.filtro,
        idPlan: this.filtroPlan,
      }

      this.$http.post(this.$api + "tratamientos/detalle/planes-tratamiento", params).then(respuesta => {
      if (respuesta.data.data) {
        this.tratamientosArray = respuesta.data.data;
        this.totalRows = this.tratamientosArray.length;
        this.cargando = false;
      }
    }).catch((error) => {
        console.error(error);
        this.cargando = false;
      })
  }
  }
}
</script>

<style scoped>

</style>